// EventLinker.js
// Kapselt die Event-Subscriptions für die TopoMap (Mediator-basiert)

import {mediator} from "../../mediator/mediatorInstance.js";
import { setMarkerActiveState } from "../marker/markerActiveState.js";

export class EventLinker {
    callbacks;

    constructor(mediator, mapAdapter) {
        this.mediator = mediator;
        this.mapAdapter = mapAdapter;
    }

    registerEvents(callbacks) {
        this.callbacks = callbacks;
        this.#subscribeToMapEvents();
        this.#subscribeToArchiveMarkerEvents();
        this.#subscribeToResultWindowEvents();
        this.#subscribeToClusterMarkerEvents();
        this.#subscribeToDocumentMarkerEvents();
    }

    #subscribeToMapEvents() {
        mediator.subscribe('map:fit:main', () => {
            this.callbacks.onMainMapFitToMarkers();
        });
        mediator.subscribe('map:fit:gallery', ({ index = null}) => {
            this.callbacks.onGalleryMapFitToMarkers(index);
        })
    }

    #subscribeToArchiveMarkerEvents() {
        mediator.subscribe('marker:archive:click', ({ data }) => {
            if (parseInt(data.online) === 1) {
                window.open('https://' + data.domain, "_blank");
            }
        });
        mediator.subscribe('marker:archive:mouseover', ({ data }) => {
            this.callbacks.onArchiveHover(data.id);
        });
        mediator.subscribe('marker:archive:mouseout', ({ data }) => {
            this.callbacks.onArchiveHover(data.id, false);
        })
    }

    #subscribeToResultWindowEvents() {
        mediator.subscribe('marker:document:highlight:on', ({docId}) => {
            this.callbacks.onDocumentHover(docId);
        });
        mediator.subscribe('marker:document:highlight:off', ({docId}) => {
            this.callbacks.onDocumentHover(docId, false);
        });
    }

    #subscribeToClusterMarkerEvents() {
        mediator.subscribe('marker:cluster:mouseover', ({ clusterMarker, event }) => {
            const docIdAttr = clusterMarker.content?.dataset?.docIds;
            const docIds = docIdAttr ? docIdAttr.split(',') : [];
            const hoverThumb = this.callbacks.onHoverShowThumbObject();
            const screenPos = event.currentTarget.getBoundingClientRect();
            hoverThumb.over(docIds, screenPos.x, screenPos.y + window.scrollY);
            setMarkerActiveState(clusterMarker, true);
        });
        mediator.subscribe('marker:cluster:mouseout', ({ clusterMarker }) => {
            setMarkerActiveState(clusterMarker, false);
            this.callbacks.onHoverShowThumbObject().out(100);
        });
    }

    #subscribeToDocumentMarkerEvents() {
        mediator.subscribe('marker:document:click', ({ marker }) => {
            const docId = marker?.customId;
            if (docId) {
                if (this.callbacks.onDocumentClick && typeof this.callbacks.onDocumentClick === 'function') {
                    this.callbacks.onDocumentClick(docId);
                } else {
                    console.warn('[FrontendMap] openGallery function not defined.');
                }
            }
        });
        mediator.subscribe('marker:document:mouseover', ({ marker, rect }) => {
            const docId = marker?.customId;
            this.callbacks.onHoverShowThumbObject().over(
                docId, rect.x + 10, rect.y + window.scrollY + 10
            );
            this.callbacks.onDocumentHover(docId);
        });
        mediator.subscribe('marker:document:mouseout', ({ marker }) => {
            const docId = marker?.customId;
            this.callbacks.onHoverShowThumbObject().out(300);
            this.callbacks.onDocumentHover(docId, false);
        });
    }
}